<template>
<div class="page">
  <div class="head_title">
    <h1>绑定手机号</h1>
    <div class="txt">需在已注册状态下进行绑定</div>
  </div>
  <div class="con">
    <input type="number" oninput="if(value.length>11)value=value.slice(0,11)" class="phone" v-model.trim="phone" placeholder="请输入手机号">
    <div class="verification_code">
      <input type="text" class="code" v-model.trim="verCode" placeholder="请输入验证码">
      <span v-if="showCutDown == false" @click="getYzm" class="txt">获取验证码</span>
      <span v-else class="cut_down">{{seconds}}秒后重发</span>
    </div>
    <div class="bind_btn" @click="bindPhone">立即绑定</div>
    <div class="tips" @click="toDownLoad">未注册？ 去下载注册</div>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      phone:'',                  // 手机号
      verCode:'',                // 验证码
      seconds:60,                // 倒计时
      timer:null,                // 定时器
      showCutDown:false,         // 是否显示倒计时
    }
  },
  watch:{
    'seconds'(){
      if(this.seconds <= 0){
        clearInterval(this.timer);
        this.showCutDown = false;
        this.seconds = 60;
      }
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    // 获取验证码
    getYzm(){
      if(!this.phone){
        this.$toast('请填写手机号码');
        return;
      }
      let postData = {
        channel:1,
        phone:this.phone
      }
      this.$http.post('/survey/sms/sendMessage',postData).then(res=>{
        if(res.code == 200){
          this.$toast('发送成功')
          this.timer = setInterval(()=>{
            this.seconds --;
          },1000)
          this.showCutDown = true;
        }
      })
    },
    // 绑定手机号
    bindPhone(){
      let postData = {
        cellPhone:this.phone,
        messageCode:this.verCode
      }
      this.$http.post('survey/userLogin/bindCellPhone',postData).then(res=>{
        this.$toast(res.message);
        if(res.code == 200){
          this.phone = '';
          this.verCode = '';
          this.$router.push({
            path:'/bindFinish'
          })
        }
      })
    },
    // 跳转到下载页面
    toDownLoad(){
      window.location.href = 'https://www.zhuowendata.com/app/zwtb.html'; 
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/invitation/bind_gzh_bg.png') no-repeat;
  background-size: cover;
  padding: 1px 24px;
  box-sizing: border-box;
  .head_title{
    margin-top: 145px;
    h1{
      width: 100%;
      font-size: 52px;
      line-height: 73px;
      color: #FFFFFF;
      padding-left: 30px;
      box-sizing: border-box;
      font-weight: 600;
    }
    .txt{
      margin-top: 8px;
      width: 100%;
      font-size: 32px;
      line-height: 45px;
      color: rgba(255,255,255,.6);
      padding-left: 30px;
      box-sizing: border-box;
    }
  }
  .con{
    margin-top: 52px;
    width: 100%;
    height: 582px;
    background: #ffffff;
    border-radius: 20px;
    padding: 0 36px;
    box-sizing: border-box;
    .phone{
      margin-top: 61px;
      width: 100%;
      height: 91px;
      background: #F0F2F8;
      border-radius: 42px;
      padding-left: 36px;
      box-sizing: border-box;
      border: 0 none;
      outline: none;
    }
    .verification_code{
      margin-top: 42px;
      position: relative;
      .code{
        width: 100%;
        height: 91px;
        background: #F0F2F8;
        border-radius: 42px;
        padding-left: 36px;
        box-sizing: border-box;
        border: 0 none;
        outline: none;
      }
      .txt{
        position: absolute;
        top: 23px;
        right: 36px;
        font-size: 32px;
        line-height: 45px;
        color: #0570C2;
      }
      .cut_down{
        position: absolute;
        top: 23px;
        right: 36px;
        font-size: 32px;
        line-height: 45px;
        color: #C1C7D4;
      }
    }
    .bind_btn{
      margin-top: 74px;
      width: 100%;
      height: 88px;
      background: linear-gradient(178deg,#0f81d9 12%, #071c76 100%);
      border-radius: 44px;
      box-shadow: 0px 10px 20px 0px rgba(12,87,175,0.25); 
      text-align: center;
      line-height: 88px;
      font-size: 32px;
      color: #FFFFFF;
    }
    .tips{
      margin-top: 63px;
      font-size: 32px;
      line-height: 45px;
      color: #0570C2;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invitation/bindPhone.vue